import {NgModule} from '@angular/core';
import {SharedModule} from '@app/shared/shared.module';
import {MaintenanceModeComponent} from './components/maintenance-mode/maintenance-mode.component';

@NgModule({
    imports: [SharedModule, MaintenanceModeComponent],
    exports: [MaintenanceModeComponent],
})
export class MaintenanceModeModule {}
